import { all } from 'redux-saga/effects'
import { taxIdSaga } from './tax-id/saga'

export function* socketSaga() {
  yield all([taxIdSaga()])
}
